module.exports = __webpack_public_path__ + "img/goods-small.a27c634a.jpg";